<template>
    <el-dialog
      title="招募状态修改"
      :visible.sync="dialogVisible"
      :close-on-click-modal=false
      :close-on-press-escape=false
      width="500px"
      @close="handleClose"
    >
      <ul class="edit-state-header">
        <li>
          <span class="label">T3： </span>
          <span class="value">{{ detailObj.organ }}</span>
        </li>
        <li>
          <span class="label">T4： </span>
          <span class="value">{{ detailObj.area }} </span>
        </li>
        <li>
          <span class="label"> 姓名： </span>
          <span class="value">{{ detailObj.accountName }}</span>
        </li>
      </ul>
      <el-form :model="form" :rules="rules"  ref="formRef" label-width="80px">
        <el-form-item label="当前状态:">
          {{ detailObj.lifeNodeDesc }}
        </el-form-item>
        <!-- 招募安排 -->
        <el-form-item label="撤销阶段" prop="step">
          <el-radio-group v-model="form.step" size="small" >
            <el-radio
              border
              v-for="(ite,idx) in revokeList"
              :key="idx"
              :label="ite.value"
            >{{ite.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="撤销原因" prop="reasons">
          <el-input
            v-model="form.reasons"
            placeholder="撤销原因"
            :rows="4"
            maxlength="200"
            type="textarea"
          ></el-input>
        </el-form-item>
  
        <div class="btns">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="submitForm">确认</el-button>
        </div>
      </el-form>
    </el-dialog>
  </template>
        
<script>
import url from "@/modules/url";
import api from "@/modules/api";
import { Options } from '@/components/utils/fixOptions'
  //  interviewerType_status
export default {
  data() {
    return {
      dialogVisible: true, // 控制对话框的显示与隐藏
      form: {
        step: "",
        reasons: "",
      },
      stepList: Options.step_status,
      revokeList: Options.revoke_status,
      detailObj: {},
      rules: {
        step:[
          { required: true, message: '请选择撤销阶段', trigger: 'change' }
        ],
        reasons:[
          { required: true, message: '请输入撤销原因', trigger: 'blur' }
        ]
      }
    };
  },
  props: {
    detailList: {
      type: Array,
      default: []
    },
  },
  mounted() {
    this.detailObj = this.detailList[0]
    console.log(this.detailObj, '================')

  },
  methods: {
    // 提交表单
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let stepLabel = this.revokeList.find(item => item.value == this.form.step).label
          this.$confirm('确定要撤销' + this.detailObj.accountName + '的' + stepLabel + '操作么？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => { 
            const { step, reasons} = this.form
            const data = {
              userId:  this.detailObj.userId,
              step: step,
              reasons: reasons
            }
            this.save(data)
          });
        } else {
          return false;
        }
      });
    },
    save(data){
      api.post(url.modifyInterviewState, data, (res) => {
        if (res.result.isSuccess) {
          this.handleClose('refresh');
        } else {
          if (res.result.errors.length > 0) {
            this.$message({
              type: 'error',
              message: res.result.errors[0].error
            });
          } else {
            this.$message({
              type: 'error',
              message: res.result.error
            });
          }
        }
      });
    },
    handleClose(flag='') {
      this.form = {
        step: "",
        reasons: "",
      };
      this.$emit("close")
      flag == 'refresh' && this.$emit("refresh")
    },
  },
};
</script>
      
<style lang="scss" scoped>
  
.btns {
  text-align: center;
}
.el-radio {
  margin-right: 10px !important;
}
.el-radio.is-bordered+.el-radio.is-bordered {
  margin: 5px 10px 5px 0 !important;
}
.edit-state-header {
  margin: 0;
  padding: 0;
  display: flex;
  flex-flow: wrap;
  width: 100%;
  margin-bottom: 15px;
  li {
    width: 50%;
    list-style: none;
    padding: 10px 0;
    .label {
      display: inline-block;
      width: 80px;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/recruit/officeSaff/component/editStateDialog.vue